<template>
  <v-container fluid grid-list-lg>

    <v-layout row wrap>
      <v-flex xs12 sm6 offset-sm3>
        <v-layout align-center justify-center column pb-2>
          <h2 class="heading-3">Activate Your Digital Account</h2>
          <p><em>A 6 digit confirmation code has been sent to your email address. Paste it into the box below and click
              Verify to activate your account.</em></p>
        </v-layout>

        <v-alert :value="true" v-if="error != null" type="error">{{ error.message }}</v-alert>

        <v-layout justify-center column>
          <v-form ref="form" v-model="valid" @submit="confirm">

            <v-text-field outline v-model="username" :rules="usernameRules" label="Email" type="email"
              required></v-text-field>

            <div class="code-input-container">
              <label class="v-label theme--light">Confirmation code</label>
              <div class="code-inputs">
                <input v-for="(digit, index) in 6" :key="index" type="text" maxlength="1" class="code-input"
                  :value="codeDigits[index]" @input="handleInput($event, index)"
                  @keydown.delete="handleDelete($event, index)" @paste="handlePaste" @focus="onFocus($event)"
                  ref="codeInputs" />
              </div>
              <div v-if="!isCodeValid && codeTouched" class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">Confirmation code must be entered</div>
                </div>
              </div>
            </div>

            <v-layout row align-center mx-1>

              <v-spacer />
              <button type="submit" class="button" :disabled="!valid || !isCodeValid">Verify</button>
            </v-layout>

          </v-form>

        </v-layout>

      </v-flex>
    </v-layout>

  </v-container>
</template>


<script>
export default {
  name: 'Login',
  data() {

    return {
      valid: true,
      codeRules: [
        v => !!v || 'Confirmation code must be enetered',
      ],
      usernameRules: [
        v => !!v || 'Email address is required',
        v => /.+@.+/.test(v) || 'Email must be valid',
        v => (!v.includes(' ')) || 'An email address can not contain any spaces'
      ],
      username: '',
      code: '',
      codeDigits: Array(6).fill(''),
      codeTouched: false,
      error: null,
      loading: false
    }
  },
  computed: {
    isCodeValid() {
      return this.code.length === 6;
    }
  },
  watch: {
    codeDigits: {
      handler(val) {
        this.code = val.join('');
      },
      deep: true
    },
    code(val) {
      // Sync codeDigits if code is updated externally (e.g. pre-filled)
      if (val && val.length === 6 && val !== this.codeDigits.join('')) {
        this.codeDigits = val.split('');
      }
    }
  },
  mounted() {

    if (localStorage.appRegistrationUsername) {
      this.username = localStorage.appRegistrationUsername
    } else {
      console.log('No email was passed from registration')
    }


  },
  methods: {
    handleInput(e, index) {
      this.codeTouched = true;
      const value = e.target.value;
      this.$set(this.codeDigits, index, value);

      // If value is entered, move to next input
      if (value && index < 5) {
        this.$refs.codeInputs[index + 1].focus();
      }
    },
    handleDelete(e, index) {
      if (!this.codeDigits[index] && index > 0) {
        this.$refs.codeInputs[index - 1].focus();
      }
    },
    handlePaste(e) {
      e.preventDefault();
      const pasteData = e.clipboardData.getData('text');
      if (pasteData) {
        const digits = pasteData.replace(/\D/g, '').slice(0, 6).split('');
        digits.forEach((digit, i) => {
          this.$set(this.codeDigits, i, digit);
        });
        // Focus the last filled input or the first empty one
        const nextIndex = Math.min(digits.length, 5);
        this.$refs.codeInputs[nextIndex].focus();
        this.codeTouched = true;
      }
    },
    onFocus(e) {
      e.target.select();
    },
    confirm(e) {
      e.preventDefault()
      this.loading = true
      var email = localStorage.appRegistrationUsername
      console.log(email)
      var confCode = this.code
      console.log("confCode", confCode)

      this.$confirmRegistration(email, confCode).subscribe((data) => {

        if (typeof window.android !== 'undefined') {
          window.android.onRegistrationConfirmed()
        }
        if (typeof window.webkit !== 'undefined') {

          window.webkit.messageHandlers.iOS.postMessage('registrationConfirmed')
        }

        console.log('confirm success');

      },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          console.log(err);
          if (err.code === "UnknownError") {
            this.$router.push("/login-set-password");
          }
          console.log(err.message);
          this.error = err;
        });

    }
  }
}
</script>

<style scoped>
.code-input-container {
  margin-bottom: 20px;
}

.code-inputs {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}

.code-input {
  width: 45px;
  height: 50px;
  font-size: 24px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 8px;
  outline: none;
  transition: border-color 0.3s;
}

.code-input:focus {
  border-color: #1976d2;
  /* Vuetify primary color or similar */
  border-width: 2px;
}
</style>